// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-dual-ring:after {
  content: "";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.lds-dual-ring-cenit {
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-dual-ring-cenit:after {
  content: "";
  display: block;
  width: 64px;
  height: 64px;
  background: url("/assets/img/loader-cenit.gif") no-repeat;
  background-size: 100% 100%;
}

@keyframes lds-dual-ring-cenit {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/spinner/spinner.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AACE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,+CAAA;EACA,6CAAA;AAEJ;;AAAE;EACE;IACE,uBAAA;EAGJ;EADE;IACE,yBAAA;EAGJ;AACF;AADE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AADE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EAMA,yDAAA;EACA,0BAAA;AADJ;;AAGE;EACE;IACE,uBAAA;EAAJ;EAEE;IACE,yBAAA;EAAJ;AACF","sourcesContent":[".lds-dual-ring {\n    display: inline-block;\n    width: 80px;\n    height: 80px;\n  }\n  .lds-dual-ring:after {\n    content: \"\";\n    display: block;\n    width: 64px;\n    height: 64px;\n    margin: 8px;\n    border-radius: 50%;\n    border: 6px solid #fff;\n    border-color: #fff transparent #fff transparent;\n    animation: lds-dual-ring 1.2s linear infinite;\n  }\n  @keyframes lds-dual-ring {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  .lds-dual-ring-cenit {\n    display: inline-block;\n    width: 80px;\n    height: 80px;\n  }\n  .lds-dual-ring-cenit:after {\n    content: \"\";\n    display: block;\n    width: 64px;\n    height: 64px;\n    // margin: 8px;\n    // border-radius: 50%;\n    // border: 6px solid #fff;\n    // border-color: #fff transparent #fff transparent;\n    // animation: lds-dual-ring 1.2s linear infinite;\n    background: url(\"/assets/img/loader-cenit.gif\") no-repeat;\n    background-size: 100% 100%;\n  }\n  @keyframes lds-dual-ring-cenit {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
